import {Component, ChangeDetectionStrategy} from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';

@Component({
    selector: 'app-divider',
    templateUrl: './divider.component.html',
    styleUrls: ['./divider.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatDividerModule]
})
export class DividerComponent {}
